import React from 'react';

import './NotFound.scss';
import {Helmet} from 'react-helmet';
/**
 * The AppPage component.
 *
 * @constructor
 */
export class NotFound extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    return (
      <div id="not-found" className="system-page">
        <Helmet>
          <title>Not Found Page - NEI</title>
          <meta name = "description" content ="Page Not Found." />
        </Helmet>
        <div className="container-fluid">
           <h2>Page Not Found</h2>
        </div>
      </div>
    );
  }
}

NotFound.propTypes = {};

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/pages/404/NotFound.js